import { render } from "./AddressDetails.vue?vue&type=template&id=c71e0030&scoped=true"
import script from "./AddressDetails.vue?vue&type=script&lang=js"
export * from "./AddressDetails.vue?vue&type=script&lang=js"

import "./AddressDetails.vue?vue&type=style&index=0&id=c71e0030&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c71e0030"

export default script